export default {"src":"/_next/static/media/new.25e7f115.svg","height":28,"width":28,"blurWidth":0,"blurHeight":0};